// extracted by mini-css-extract-plugin
export default {"separatorWrapper":"PA1wIW","separator":"NaeDMq"};